import {
  createElement,
  type AnchorHTMLAttributes,
  type ComponentType,
  type ImgHTMLAttributes,
} from "react";

export type StratosImagePrimitiveProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  imageClassName?: string;
  priority?: boolean;
  src: string;
};

export type StratosLinkPrimitiveProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
};

export type StratosPrimitiveRegistry = {
  Image: ComponentType<StratosImagePrimitiveProps>;
  Link: ComponentType<StratosLinkPrimitiveProps>;
};

export type StratosPrimitiveName = keyof StratosPrimitiveRegistry;

const Image = ({ imageClassName, priority: _priority, ...props }: StratosImagePrimitiveProps) =>
  createElement("img", {
    ...props,
    className: [props.className, imageClassName].filter(Boolean).join(" ") || undefined,
  });

const Link = ({ children, rel, target, ...props }: StratosLinkPrimitiveProps) =>
  createElement(
    "a",
    { ...props, rel: target === "_blank" && !rel ? "noopener noreferrer" : rel, target },
    children,
  );

const registry: StratosPrimitiveRegistry = { Image, Link };

export function registerComponent<K extends StratosPrimitiveName>(
  name: K,
  component: StratosPrimitiveRegistry[K],
) {
  registry[name] = component;
}

export function getComponent<K extends StratosPrimitiveName>(name: K): StratosPrimitiveRegistry[K] {
  return registry[name];
}
